import { render, staticRenderFns } from "./accountsReceiveData.vue?vue&type=template&id=f876f552&scoped=true&"
import script from "./accountsReceiveData.vue?vue&type=script&lang=js&"
export * from "./accountsReceiveData.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceiveData.vue?vue&type=style&index=0&id=f876f552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f876f552",
  null
  
)

export default component.exports